<template>
    <div id="profile-page">

        <!-- PROFILE HEADER -->
        <div class="profile-header">
            <div class="relative">
                <div class="cover-container rounded-t-lg gradient-bg" style="height:100px;">
                    
                </div>
                <div class="profile-img-container pointer-events-none">
                    <div>
                        <vs-avatar class="user-profile-img" :src="activeUserInfo.photoURL" size="85px" />
                    </div>
                    <div class="profile-actions pointer-events-auto flex">
                        <vs-button class="mb-2" icon-pack="feather" radius icon="icon-settings" to='/profile/settings'></vs-button>
                        <!-- <vs-button icon-pack="feather" radius icon="icon-send" class="ml-2 lg:ml-4"></vs-button> -->
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-end flex-wrap profile-header-nav p-6">
                <div class="w-full flex-grow sm:flex sm:items-center sm:w-auto">
                    <div class="text-sm sm:flex-grow">
                        <ul class="sm:flex justify-around mt-9 w-full md:mt-0 md:ml-auto md:w-3/4">
                            <li class="p-2 sm:p-0">{{ activeUserInfo.displayName }}</li>
                            <li class="p-2 sm:p-0" v-if="userData.phone.length > 0" >Cel: {{ evolugyUser.phone[0] }}</li>
                            <li class="p-2 sm:p-0" v-if="userData.specialty">{{evolugyUser.specialty}}</li>
                            <li class="p-2 sm:p-0" v-if="userData.address">{{evolugyUser.address}} <span v-if="evolugyUser.zone">| Zona {{evolugyUser.zone}}</span> </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <vx-navbar> -->
            <!-- </vx-navbar> -->
        </div>

        <vx-card class="mt-6">
          <div>
              <div class="mt-5">
                <vs-tabs alignment="fixed">
                  <!-- CUENTA -->
                  <vs-tab label="Cuenta">
                    <!-- Cuenta  -->
                    <div>
                      <div class="vx-row mt-3">
                        <div class="vx-col w-full md:w-1/2">

                          <!-- Col Header -->
                          <div class="flex items-end mb-6">
                            <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
                            <span class="leading-none font-medium">Información Personal</span>
                          </div>

                          <!-- Col Content -->
                          <div>
                            
                            <div v-if="!editting" class="">
                              <div class="vx-row w-full pl-5 mt-4">
                                <h5 class="w-full">Nombres</h5>
                                <p class="mt-1 ml-2"> {{activeUserInfo.first_name}} {{activeUserInfo.last_name}} </p>
                              </div>
                              <div class="vx-row w-full pl-5 mt-4">
                                <h5 class="w-full">Fecha de Nacimiento</h5>
                                <p class="mt-1 ml-2"> {{activeUserInfo.dob ? activeUserInfo.dob.substring(0,10) : ''}}</p>
                              </div>
                              <div class="vx-row w-full pl-5 mt-4">
                                <h5 class="w-full">Género</h5>
                                <p class="mt-1 ml-2"> {{activeUserInfo.gender == 'male' ? 'Masculino' : 'Femenino' }}</p>
                              </div>
                              <div class="vx-row w-full pl-5 mt-4">
                                <h5 class="w-full">Celulares</h5>
                                <p class="mt-2 ml-2 w-full" v-for="(phone,i) in activeUserInfo.phone" :key="i" >{{phone}}</p>
                              </div>
                              <div class="vx-row w-full pl-5 mt-4">
                                <h5 class="w-full">Email</h5>
                                <p class="mt-1 ml-2"> {{activeUserInfo.email}}</p>
                              </div>
                              <div class="vx-row w-full pl-5 mt-4">
                                <h5 class="w-full">URL de LinkedIn </h5>
                                <a class="mt-2 ml-2 w-full" v-if="activeUserInfo.linkedin" :href="activeUserInfo.linkedin" >{{activeUserInfo.linkedin}}</a>
                                <p v-else class="ml-2">Sin Definir</p>
                              </div>
                              
                            </div>

                            <div v-if="editting">
                              <!-- Nombres -->
                              <vs-input class="w-full mt-4" label="Nombres"  v-validate="'required'" name="nombres" 
                                v-model="userData.first_name" 
                              />
                              <span class="text-danger text-sm"  v-show="errors.has('nombres')">{{ errors.first('nombres') }}</span>

                              <!-- Apellidos -->
                              <vs-input class="w-full mt-4" label="Apellidos"  v-validate="'required'" name="apellidos" 
                                v-model="userData.last_name" 
                              />
                              <!-- <span class="text-danger text-sm"  v-show="errors.has('addd_line_1')">{{ errors.first('addd_line_1') }}</span> -->

                              <!-- DOB -->
                              <div class="mt-6">
                                <label class="text-sm">Fecha de Nacimiento</label>
                                <flat-pickr v-model="userData.dob" :config="{ dateFormat: 'd F Y', maxDate: new Date() }" class="w-full" v-validate="'required'" name="nacimiento" />
                                <span class="text-danger text-sm" >{{ errors.first('nacimiento') }}</span>
                              </div>
                              <!-- CEL -->
                              <div>
                                <vs-input class="w-full mt-4" label="Celular" v-validate="{regex: '^\\+?([0-9]+)$' }" name="celular" 
                                  v-model="userData.phone[0]"
                                />
                                <span class="text-danger text-sm"  v-show="errors.has('celular')">{{ errors.first('celular') }}</span>
                              </div>
                              <!-- LINKED - IN -->
                              <div>
                                <vs-input class="w-full mt-4" label="URL Linkedin"  v-validate="'url:require_protocol'" name="linkedin" data-vv-as="field" v-model="userData.linkedin" />
                                <span class="text-danger text-sm"  v-show="errors.has('linkedin')">{{ errors.first('linkedin') }}</span>
                              </div>
                              <!-- Gender -->
                              <div class="mt-4">
                                <label class="text-sm">Género</label>
                                <div class="mt-2">
                                  <vs-radio class="mr-4" v-model="userData.gender"  vs-value="male" >Masculino</vs-radio>
                                  <vs-radio class="mr-4" v-model="userData.gender"  vs-value="female">Femenino</vs-radio>
                                </div>
                              </div>

                            </div>

                          </div>
                        </div>

                        <!-- Address Col -->
                        <div class="vx-col w-full md:w-1/2">

                            <!-- Col Header -->
                            <div class="flex items-end md:mt-0 mt-base mb-6">
                              <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
                              <span class="leading-none font-medium">Dirección</span>
                            </div>

                            <div v-if="!editting">
                              <div class="vx-row w-full pl-5">
                                <h5 class="w-full">Dirección Principal</h5>
                                <p class="mt-1 ml-2" v-if="activeUserInfo.address">{{activeUserInfo.address}}</p>
                                <p class="mt-1 ml-2" v-else>Sin Definir</p>
                              </div>
                              <div class="vx-row w-full pl-5 mt-4">
                                <h5 class="w-full">Dirección Complementaria</h5>
                                <p class="mt-1 ml-2" v-if="activeUserInfo.address_2"> {{activeUserInfo.address_2}}</p>
                                <p class="mt-1 ml-2" v-else>Sin Definir</p>
                              </div>
                              <div class="vx-row w-full pl-5 mt-4">
                                <h5 class="w-full">Zona</h5>
                                <p class="mt-1 ml-2" v-if="activeUserInfo.zone">{{activeUserInfo.zone}}</p>
                                <p class="mt-1 ml-2" v-else>Sin Definir</p>
                              </div>
                              <div class="vx-row w-full pl-5 mt-4">
                                <h5 class="w-full">Ciudad</h5>
                                <p class="mt-1 ml-2" v-if="activeUserInfo.city">{{activeUserInfo.city}}</p>
                                <p class="mt-1 ml-2" v-else>Sin Definir</p>
                              </div>
                              
                              <div class="vx-row w-full pl-5 mt-4">
                                <h5 class="w-full">País</h5>
                                <p class="mt-1 ml-2" v-if="activeUserInfo.country">{{activeUserInfo.country}}</p>
                                <p class="mt-1 ml-2" v-else>Sin Definir</p>
                              </div>
                              
                            </div>

                            <!-- editting Col Content -->
                            <div v-if="editting">
                              <vs-input class="w-full mt-4" label="Dirección Principal"  v-validate="'required'" name="direccion" v-model="userData.address" />
                              <span class="text-danger text-sm"  v-show="errors.has('direccion')">{{ errors.first('direccion') }}</span>

                              <vs-input class="w-full mt-4" label="Dirección Complementaria"  v-validate="'required'" name="complementaria" v-model="userData.address_2" />
                              <span class="text-danger text-sm"  v-show="errors.has('complementaria')">{{ errors.first('complementaria') }}</span>

                              <vs-input class="w-full mt-4" label="Zona"  v-validate="'required|numeric'" name="zona" v-model="userData.zone" />
                              <span class="text-danger text-sm"  v-show="errors.has('zona')">{{ errors.first('zona') }}</span>

                              <vs-input class="w-full mt-4" label="Ciudad"  v-validate="'required|alpha'" name="ciudad" v-model="userData.city" />
                              <span class="text-danger text-sm"  v-show="errors.has('ciudad')">{{ errors.first('ciudad') }}</span>

                              <vs-input class="w-full mt-4" label="País" v-validate="'required|alpha'" name="pais" v-model="userData.country" />
                              <span class="text-danger text-sm"  v-show="errors.has('pais')">{{ errors.first('pais') }}</span>

                            </div>
                        </div>
                        <vs-row class="mt-4 w-full">
                          <vs-col class="flex flex-col items-end pr-5">
                            <vs-button v-if="editting" @click="submitForm();" class="" color="success">Guardar Cambios</vs-button>
                            <vs-button v-if="editting" @click="editting = !editting" class=" mt-2" color="danger">Cancelar</vs-button>
                            <vs-button v-if="!editting" @click="editting = !editting" class="" color="warning">Editar</vs-button>
                          </vs-col>
                          
                        </vs-row>
                      </div>
                    </div>
                  </vs-tab>
                  <!-- EQUIPO -->
                  <vs-tab label="Equipo" v-if="activeUserInfo.role && activeUserInfo.role == 'doctor'">
                    <div class="vx-row">
                      <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-for="(secretary, index) in this.secretariesList" :key="index">
                          <vx-card class="p-2" >
                              <vs-avatar class="mx-auto mb-6 block" size="70px" icon = "assignment_ind" style="font-size: 40px;" />
                              <div class="text-center">
                                  <h4>{{ secretary.first_name + " " + secretary.last_name }}</h4>
                                  <p class="text-grey">{{ secretary.role }}</p>
                              </div>
                              <div class="flex justify-center flex-wrap">
                                  <vs-button 
                                    class="mt-4 mr-2 shadow-lg"  color="primary"
                                    @click="openTeamMemberModal(secretary)"
                                  >Ver</vs-button>
                                  <vs-button 
                                    class="mt-4 mr-2 shadow-lg"  color="warning"
                                    @click="editNewSecretaryForm(secretary)"
                                  >Editar</vs-button>
                                  <vs-button 
                                    class="mt-4 mr-2 shadow-lg"  color="danger"
                                    @click="openRemoveSecretaryModal(secretary)"
                                  >Remover</vs-button>
                              </div>
                              <template slot="footer">
                                  <vs-divider />
                                  <div class="flex justify-between">
                                      <!-- <span class="flex items-center">
                                          <feather-icon :icon="card_4.footer_text_1_icon" svgClasses="h-5 w-5 text-warning stroke-current" />
                                          <span class="ml-2">{{ card_4.footer_text_1 }}</span>
                                      </span>
                                      <span class="flex items-center">
                                          <feather-icon :icon="card_4.footer_text_2_icon" svgClasses="h-5 w-5 text-primary stroke-current" />
                                          <span class="ml-2">{{ card_4.footer_text_2 }}</span>
                                      </span> -->
                                  </div>
                              </template>
                          </vx-card>
                      </div>
                        <vs-row class="mt-4 w-full">
                          <vs-col class="flex flex-col items-end pr-5">
                            <vs-button @click="openNewSecretaryForm" class="" color="primary">Agregar miembro</vs-button>
                            <!-- <vs-button v-if="editting" @click="editting = !editting" class=" mt-2" color="danger">Cancelar</vs-button>
                            <vs-button v-if="!editting" @click="editting = !editting" class="" color="warning">Editar</vs-button> -->
                          </vs-col>
                          
                        </vs-row>
                    </div>
                  </vs-tab>
                  <vs-tab label="Clínicas" v-if="activeUserInfo.role && activeUserInfo.role == 'doctor'">
                    <div class="vx-row">
                      <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-for="(clinic, index) in this.clinicsList" :key="index">
                          <vx-card class="p-2" >
                              <vs-avatar class="mx-auto mb-6 block" size="70px" icon = "assignment_ind" style="font-size: 40px;" />
                              <div class="text-center">
                                  <h4>{{ clinic.title }}</h4>
                              </div>
                              <div class="flex justify-center flex-wrap">
                                  <vs-button 
                                    class="mt-4 mr-2 shadow-lg"  color="primary"
                                    @click="openClinicModal(clinic)"
                                  >Ver</vs-button>
                                  <vs-button 
                                    class="mt-4 mr-2 shadow-lg"  color="warning"
                                    @click="editNewClinicForm(clinic)"
                                  >Editar</vs-button>
                              </div>
                              <template slot="footer">
                                  <vs-divider />
                                  <div class="flex justify-between">
                                      <!-- <span class="flex items-center">
                                          <feather-icon :icon="card_4.footer_text_1_icon" svgClasses="h-5 w-5 text-warning stroke-current" />
                                          <span class="ml-2">{{ card_4.footer_text_1 }}</span>
                                      </span>
                                      <span class="flex items-center">
                                          <feather-icon :icon="card_4.footer_text_2_icon" svgClasses="h-5 w-5 text-primary stroke-current" />
                                          <span class="ml-2">{{ card_4.footer_text_2 }}</span>
                                      </span> -->
                                  </div>
                              </template>
                          </vx-card>
                      </div>
                        <vs-row class="mt-4 w-full">
                          <vs-col class="flex flex-col items-end pr-5">
                            <vs-button @click="openNewClinicForm" class="" color="primary">Agregar clínica</vs-button>
                            <!-- <vs-button v-if="editting" @click="editting = !editting" class=" mt-2" color="danger">Cancelar</vs-button>
                            <vs-button v-if="!editting" @click="editting = !editting" class="" color="warning">Editar</vs-button> -->
                          </vs-col>
                          
                        </vs-row>
                    </div>
                  </vs-tab>
                </vs-tabs>
              </div>
          </div>
        </vx-card>
          <modal
            name="teamMemberModal"
            height="auto"
            :scrollable="true"
            style="z-index: 1001;"
          >
            <div class="p-3">
               <vx-card title="Descripción" class="">
                    <!-- ACTION SLOT -->
                    <!-- <template slot="actions">
                        <feather-icon icon="MoreHorizontalIcon"></feather-icon>
                    </template> -->

                    <!-- USER BIO -->
                    <div class="user-bio">
                        <p>{{ this.secretaryModalView.meta.about }}</p>
                    </div>

                    <!-- OTEHR DATA -->
                    <div class="mt-5">
                        <h6>Nombre:</h6>
                        <p>{{ this.secretaryModalView.first_name + " " + this.secretaryModalView.last_name }}</p>
                    </div>

                    <div class="mt-5">
                        <h6>Se creó:</h6>
                        <p>{{ this.getCreatedDateSecretary() }}</p>
                    </div>

                    <div class="mt-5">
                        <h6>vive en:</h6>
                        <p>{{ this.secretaryModalView.address }}</p>
                    </div>

                    <div class="mt-5">
                        <h6>Email:</h6>
                        <p>{{ this.secretaryModalView.email }}</p>
                    </div>

                    <!-- <div class="mt-5">
                        <h6>Linked In:</h6>
                        <p>linkedin.com/nicolem123</p>
                    </div>

                    <div class="social-links flex mt-4">
                        <feather-icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="FacebookIcon"></feather-icon>
                        <feather-icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="TwitterIcon"></feather-icon>
                        <feather-icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="InstagramIcon"></feather-icon>
                    </div> -->
                </vx-card>
            </div>
          </modal>
          <modal
            name="clinicModal"
            height="auto"
            :scrollable="true"
            style="z-index: 1001;"
          >
            <div class="p-3">
               <vx-card title="Descripción" class="">
                    <!-- ACTION SLOT -->
                    <!-- <template slot="actions">
                        <feather-icon icon="MoreHorizontalIcon"></feather-icon>
                    </template> -->

                    <!-- USER BIO -->
                    <div class="user-bio">
                        <p>{{ this.clinicModalView.city }}</p>
                    </div>

                    <!-- OTEHR DATA -->
                    <div class="mt-5">
                        <h6>Nombre:</h6>
                        <p>{{ this.clinicModalView.title }}</p>
                    </div>

                    <div class="mt-5">
                        <h6>Se creó:</h6>
                        <p>{{ this.clinicModalView.created_at }}</p>
                    </div>

                    <div class="mt-5">
                        <h6>vive en:</h6>
                        <p>{{ this.clinicModalView.address }}</p>
                    </div>

                    <div class="mt-5">
                        <h6>Teléfono:</h6>
                        <p>{{ this.clinicModalView.phone[0] }}</p>
                    </div>

                    <!-- <div class="mt-5">
                        <h6>Linked In:</h6>
                        <p>linkedin.com/nicolem123</p>
                    </div>

                    <div class="social-links flex mt-4">
                        <feather-icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="FacebookIcon"></feather-icon>
                        <feather-icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="TwitterIcon"></feather-icon>
                        <feather-icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="InstagramIcon"></feather-icon>
                    </div> -->
                </vx-card>
            </div>
          </modal>
          <!-- Crear Secretaria -->
          <modal
            name="newSecretaryModal"
            height="auto"
            width="60%"
            :scrollable="true"
            style="z-index: 1005;"
          >
            <form data-vv-scope="new-secretary">

            
              <div class="vx-row my-3 ml-1">
                <div class="vx-col w-full" >
                <h2>{{ this.editingSecretary ? "Editar" : "Agregar" }} Secretaria</h2>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center" >
                  <vs-input class="w-full px-5" label="Nombre(s)*" placeholder="Nombre(s)"
                  name="nombres" v-validate="'required'" v-model="newSecretary.first_name"/>
                  <span class="text-danger">{{ errors.first('new-secretary.nombres') }}</span>
                </div>
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" label="Apellidos(s)*" placeholder="Apellidos(s)"
                  name="apellidos" v-validate="'required'" v-model="newSecretary.last_name" />
                  <span class="text-danger">{{ errors.first('new-secretary.apellidos') }}</span>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" label="Celular*" placeholder="Celular"
                  name="celular" v-validate="'required|digits:8'" v-model="newSecretary.phone[0]"/>
                  <span class="text-danger">{{ errors.first('new-secretary.celular') }}</span>
                </div>
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                  <vs-input :disabled="this.editingSecretary" class="w-full px-5" label="Correo Electrónico*" placeholder="Correo Electrónico"
                  name="email" v-validate="'required|email'" v-model="newSecretary.email"/>
                  <span class="text-danger">{{ errors.first('new-secretary.email') }}</span>
                </div>
              </div>
              <!-- <div class="vx-row mt-4 mb-5">
                <div class="vx-col  w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" label="Correo Electrónico*" placeholder="Correo Electrónico"
                  name="email" v-validate="'required|email'" v-model="newSecretary.email"/>
                  <span class="text-danger">{{ errors.first('new-secretary.email') }}</span>
                </div>
              </div> -->
              <div>
                <!-- <div class="vx-row mt-4 mb-4">
                  <div class="vx-col w-full md:w-1/3 flex flex-col inline">
                      <p class="inline px-5 mb-3" style="font-size: 13px;">Sexo*</p>
                      <ul class="ml-6">
                        <li class="ml-3">
                          <vs-radio v-model="newSecretary.gender" name="sexo" v-validate="'required'" vs-value="male">
                            Másculino
                          </vs-radio>
                        </li>
                        <li class="ml-3">
                          <vs-radio v-model="newSecretary.gender" name="sexo" v-validate="'required'" vs-value="female">
                            Femenino
                          </vs-radio>
                        </li>
                      </ul>
                      <span class="text-danger ml-5">{{ errors.first('new-secretary.sexo') }}</span>
                  </div>
                  <div class="vx-col w-full md:w-2/3 flex flex-col inline">
                      <p class="pl-5" style="font-size: 13px;">Fecha de Nacimiento*</p>
                      <datepicker class="px-5" placeholder="Seleccionar Fecha" format="yyyy-MM-dd" 
                        name="fecha_de_nacimiento" v-validate="'required'" v-model="newSecretary.dob"></datepicker>
                      <span class="ml-5 text-danger">{{ errors.first('new-secretary.fecha_de_nacimiento') }}</span>
                  </div>
                </div> -->
                <!-- <div class="vx-row mt-4 mb-2">
                  <div class="vx-col w-full md:w-full flex flex-col inline">
                      <p class="pl-5" style="font-size: 13px;">Identificación*</p>
                      <div class="vx-row">
                          <div class="vx-col w-1/3">
                              <v-select class="pl-5" placeholder="Documento" :options="['DPI','Cédula', 'Pasaporte']" :dir="$vs.rtl ? 'rtl' : 'ltr'"  
                              name="tipo" v-validate="'required'" v-model="newSecretary.idType" />
                              <span class="pl-5 text-danger">{{ errors.first('new-secretary.tipo') }}</span>
                          </div>
                          <div class="vx-col w-2/3 ">
                              <vs-input class="px-5 inputx w-full"  placeholder="Número de identificación"
                                name="identificacion" v-validate="'required'" v-model="newSecretary.idNum" />
                              <span class="ml-5 text-danger">{{ errors.first('new-secretary.identificacion') }}</span>
                          </div>
                      </div>
                  </div>
                </div> -->
                 <div class="vx-row mb-1">
                  <div class="vx-col w-full md:w-full flex flex-col inline">
                      <div class="vx-row">
                          <div class="vx-col w-1/2">
                              <p class="pl-5" style="font-size: 13px;">Rol</p>
                              <v-select class="pl-5" placeholder="Rol" :options="['secretaria', 'enfermera']" :dir="$vs.rtl ? 'rtl' : 'ltr'"  
                              name="role" label="name" v-validate="''" v-model="newSecretary.role" />
                              <span class="pl-5 text-danger">{{ errors.first('new-secretary.role ') }}</span>
                          </div>
                      </div>
                  </div>
                </div>
                <!-- <div class="vx-row">
                  <div class="vx-col w-full md:w-full flex flex-col inline">
                      <div class="vx-row">
                          <div class="vx-col w-1/2">
                              <vs-input class="pl-5 inputx w-full" label="Dirección" placeholder="Dirección"
                                name="direccion" v-validate="''" v-model="newSecretary.address" />
                              <span class="pl-5 text-danger">{{ errors.first('new-secretary.direccion') }}</span>
                          </div>
                          <div class="vx-col w-1/2 ">
                              <vs-input class="pr-5 inputx w-full" label="Complemento" placeholder="Complemento dirección"
                                name="direccion_2" v-validate="''" v-model="newSecretary.address_2" />
                              <span class="ml-5 text-danger">{{ errors.first('new-secretary.direccion_2') }}</span>
                          </div>
                      </div>
                  </div>
                </div>
              <div class="vx-row mt-4 mb-5">
                <div class="vx-col  w-full flex flex-col items-center">
                  <vs-textarea class="vx-col w-1/2" rows="3" label="Agregar descripción:"  
                  name="descripcion" v-validate="'required'" v-model="newSecretary.about"/>
                  <span class="text-danger">{{ errors.first('new-secretary.descripcion') }}</span>
                </div>
              </div> -->
                
              </div>
              
              <vs-divider class="mt-6 mb-5" />

              <div class="vx-row pt-3 pb-6">
                <div class="vx-col w-full flex justify-center">
                  <vs-button v-if="!this.editingSecretary" class="mr-4" color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle"
                    @click="validateNewSecretary">
                    Agregar
                  </vs-button>
                  <vs-button v-if="this.editingSecretary" class="mr-4" color="dark" type="filled" icon-pack="feather" icon="icon-save"
                    @click="validateNewSecretary">
                    Guardar Cambios
                  </vs-button>
                  <vs-button class="mr-4" color="warning" type="filled" icon-pack="feather" icon="icon-trash"
                    @click="cleanNewSecretaryForm">
                    Limpiar
                  </vs-button>
                  <!-- <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-list" 
                    v-if="!registerPatient" @click="registerPatient = !registerPatient">
                    Registrar Datos
                  </vs-button> -->
                  <!-- <vs-button color="danger" class="mr-4" type="filled" icon-pack="feather" icon="icon-list" 
                    v-if="registerPatient" @click="registerPatient = !registerPatient">
                    Cancelar
                  </vs-button>
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-save" 
                    v-if="registerPatient" @click="validateNewPatient">
                    Registrar Usuario
                  </vs-button> -->
                </div>
              </div>
            </form>
          </modal>

          <!-- Remover Secretaria -->
          <modal
            name="removeSecretaryModal"
            height="auto"
            width="50%"
            style="z-index: 1001;"
          >
            <div class="p-4" @click.self="close">
              <div class="vx-row ">
                <!-- <div class="mt-3 mb-4 vx-col w-full flex flex-col items-center">
                  <img src="@/assets/images/logo/logo.png" style="width: 70px; height: 70px;" >
                </div> -->
                <div class="mb-4 vx-col w-full flex flex-col text-center">
                  <h3>¿Desea remover a esta persona de su equipo?</h3>
                </div>
                <div class="mb-4 mt-5  vx-col w-full flex flex-col items-center">
                  <vs-button  class="w-1/4" color="danger" type="filled" icon="delete" @click="removeSecretary">Si</vs-button>
                  <vs-button  class="mt-3 w-1/4" color="success" type="filled" icon="close" @click="closeRemoveSecretaryModal">Cancelar</vs-button>
                </div>
              </div>
            </div>
          </modal>
          <modal
            name="RemoveClinicModal"
            height="auto"
            width="50%"
            style="z-index: 1001;"
          >
            <div class="p-4" @click.self="close">
              <div class="vx-row ">
                <!-- <div class="mt-3 mb-4 vx-col w-full flex flex-col items-center">
                  <img src="@/assets/images/logo/logo.png" style="width: 70px; height: 70px;" >
                </div> -->
                <div class="mb-4 vx-col w-full flex flex-col text-center">
                  <h3>¿Desea remover esta clínica?</h3>
                </div>
                <div class="mb-4 mt-5  vx-col w-full flex flex-col items-center">
                  <vs-button  class="w-1/4" color="danger" type="filled" icon="delete" @click="RemoveClinic">Si</vs-button>
                  <vs-button  class="mt-3 w-1/4" color="success" type="filled" icon="close" @click="closeRemoveClinicModal">Cancelar</vs-button>
                </div>
              </div>
            </div>
          </modal>

          <!-- Vincular Secretaria -->
          <modal
            name="linkSecretaryModal"
            height="auto"
            width="50%"
            style="z-index: 1001;"
          >
            <div class="p-4" @click.self="close">
              <div class="vx-row ">
                <!-- <div class="mt-3 mb-4 vx-col w-full flex flex-col items-center">
                  <img src="@/assets/images/logo/logo.png" style="width: 70px; height: 70px;" >
                </div> -->
                <div class="mb-4 vx-col w-full flex flex-col text-center">
                  <h3>¿Desea agregar a esta persona a su equipo?</h3>
                </div>
                <div class="mb-4 mt-5  vx-col w-full flex flex-col items-center">
                  <vs-button class="w-1/4" color="success" type="filled" icon="add_box" @click="linkSecretary">Si</vs-button>
                  <vs-button class="mt-3 w-1/4" color="danger" type="filled" icon="close" @click="closeLinkSecretaryModal">Cancelar</vs-button>
                </div>
              </div>
            </div>
          </modal>
          <modal
      name="newClinicModal"
      height="auto"
      width="60%"
      :draggable="true"
      :resizable="true"
    >
      <div class="p-3">
        <form data-vv-scope="new-clinic">
          <div class="vx-row w-full mt-2 pl-4 pb-1"><h3>Nueva Clínica</h3></div>
          <div class="vx-col w-full">
            <p class="my-1 ml-3">Titulo*</p>
          </div>
          <div class="vx-col w-full">
            <vs-input name="titulo"  class="w-full"  v-model="newClinic.title" v-validate="'required'"></vs-input>
            <span class="text-danger">{{ errors.first('new-clinic.titulo') }}</span>
          </div>

          <div class="vx-col w-full">
            <p class="mt-3 mb-1 ml-3">Teléfono*</p>
          </div>
          <div class="vx-col w-full">
            <vs-input name="telefono"  class="w-full"  v-model="newClinic.phone" v-validate="'required|digits:8'"></vs-input>
            <span class="text-danger">{{ errors.first('new-clinic.telefono') }}</span>
          </div>
          
          <div class="vx-col w-full" v-if="newClinic.type !== 'Virtual'">
            <p class="mt-3 mb-1 ml-3">Dirección*</p>
          </div>
          <div class="vx-col w-full" v-if="newClinic.type !== 'Virtual'">
            <vs-input name="direccion" v-validate="'required'" class="w-full"  v-model="newClinic.address"></vs-input>
            <span class="text-danger">{{ errors.first('new-clinic.direccion') }}</span>
          </div>
          <div class="vx-row" v-if="newClinic.type !== 'Virtual'">
            <div class="vx-col w-1/2">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <p class="mt-3 mb-1 ml-3">Dirección Complementaria</p>
                </div>
                <div class="vx-col w-full">
                  <vs-input name="complemento" v-validate="''" class="w-full"  v-model="newClinic.address2"></vs-input>
                  <span class="text-danger">{{ errors.first('new-clinic.complemento') }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col w-1/2">
              <div class="vx-row">
                <div class="vx-col w-full">
                <p class="mt-3 mb-1 ml-3">Zona*</p>
              </div>
              <div class="vx-col w-full">
                <vs-input name="zona" v-validate="'digits:2|required'" class="w-full"  v-model="newClinic.zone"></vs-input>
                <span class="text-danger">{{ errors.first('new-clinic.zona') }}</span>
              </div>
              </div>
            </div>
          </div>
          
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <p class="mt-3 ml-3">País*</p>
                </div>
                <div class="vx-col w-full">
                  <v-select :options="getCountries" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    name="pais" label="name" v-validate="'required'" class="w-full"  v-model="newClinic.country" />
                  <span class="text-danger">{{ errors.first('new-clinic.pais') }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col w-1/2">
              <div class="vx-row">
                <div class="vx-col w-full">
                <p class="mt-3 mb-1 ml-3">Ciudad*</p>
              </div>
              <div class="vx-col w-full">
                <v-select :disabled="newClinic.country ? false : true" :options="newClinic.country ? getStatesC : []" :dir="$vs.rtl ? 'rtl' : 'ltr'" 
                  name="ciudad" v-validate="'required'" class="w-full"  v-model="newClinic.city" />
                <span class="text-danger">{{ errors.first('new-clinic.ciudad') }}</span>
              </div>
              </div>
            </div>
          </div>

          <div class="vx-col w-full mt-4">
            <p class="my-1 ml-3">Notas Adicionales</p>
          </div>
          <div class="vx-col w-full">
            <vs-textarea name="notas" v-validate="''" class="w-full"  v-model="newClinic.notes" />
          </div>
          <div class="vx-col w-full">
            <p class="mt-6 ml-3"  style="font-size: 13px; color:#00a7e1 ">
              *Para activar tu clinica virtual de Zoom debes ir a:
              <span @click="goSettings" class="ml-2" style="font-weight: 600">
                <feather-icon
                  icon='SettingsIcon'
                  svgClasses="w-5 h-5 m-1"
                  class="" />
                Ajustes/Conexiones
              </span>
            </p>
          </div>
          <vs-divider style="margin-top: 20px;"></vs-divider>
          <div class="vx-col w-full flex flex-col items-center mt-2">
            <vs-button class="px-5" color="primary" type="filled" @click="validateNewClinic">Agregar</vs-button>
          </div>
        </form>
      </div>
    </modal>
    </div>
</template>

<script>

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import moment from 'moment'
// country state picker functions
import * as CSP from 'country-state-picker';

export default {
  data () {
    return {
      linkedSecretary: {},
      deleteClinic: null,
      editingSecretary: false,
      evolugyUser: {},
      teamMember: {},
      editting: false,
      clinicModalView: {
        address: null,
        address_2: null,
        city: null,
        country: null,
        created_at: null,
        created_by: null,
        created_by_id: null,
        deleted: false,
        deleted_at: null,
        id: null,
        location: null,
        longitude: null,
        meta: {
          type: null,
          weekDays: null
        },
        notes: null,
        phone: [null],
        state: null,
        title: null,
        updated_at: null,
        zone: null
      },
      newClinic: {
        title: null,
        phone: null,
        address: null,
        address2: null,
        zone: null,
        country: null,
        city: null,
        notes: null,
        type: 'Presencial'
      },
      newClinicDef: {
        title: null,
        phone: null,
        address: null,
        address2: null,
        zone: null,
        country: null,
        city: null,
        notes: null,
        type: 'Presencial'
      },
      secretaryModalView: {
        first_name: null,
        last_name: null,
        email: null,
        dob: null,
        gender: null,
        phone: [null,null],
        notification_prefs: ['email'],
        address: null,
        address_2: null,
        zone: null,
        city: null,
        country: null,
        role: 'secretary',
        idType: null,
        idNum: null,
        meta: {
          about: null,
        }
      },
      newSecretary: {
        about: null,
        first_name: null,
        last_name: null,
        email: null,
        dob: null,
        gender: null,
        phone: [null,null],
        notification_prefs: ['email'],
        address: null,
        address_2: null,
        zone: null,
        city: null,
        country: null,
        role: 'secretary',
        idType: null,
        idNum: null,
        meta: {},
      },
      editingClinic: false,
      newSecretaryDefault: {
        about: null,
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        dob: null,
        gender: null,
        phone: [],
        notification_prefs: ['email'],
        address: null,
        address_2: null,
        zone: null,
        city: null,
        country: null,
        role: 'secretary',
        idType: null,
        idNum: null,
        meta: {}
      },
      userData: {},
      // ---
      isNavOpen: false,
      userPoll: '',
      user_info: {
        profile_img: require('@/assets/images/profile/user-uploads/user-13.jpg'),
        cover_img: require('@/assets/images/profile/user-uploads/cover.jpg')
      },
      wasSidebarOpen: null,
      card_4: {
        name: 'Nicole Molina',
        userImg: 'https://dev.evolugy.com/img/avatar-s-12.9b7e1e0f.jpg',
        profession: 'Asistente',
        footer_text_1_icon: 'StarIcon',
        footer_text_1: '4.9',
        footer_text_2_icon: 'BriefcaseIcon',
        footer_text_2: '20 Consultas'

      }
    }
  },
  computed: {
    clinicsList() {
      console.log(this.$store.state.clinics)
      return this.$store.state.clinics;
    },
    secretariesList (){
      return this.$store.state.secretaries;
    },
    getCountries(){
      return CSP.getCountries();
    },
    getStatesC() {
      return CSP.getStates(this.newClinic.country.code)
    },
    getStates(){
      return CSP.getStates(this.newSecretary.country.code);
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    activeEvolugyUserInfo () {
      return this.$store.state.EvolugyActiveUser
    },
    mediaType () {
      return (media) => {
        if (media.img) {
          const ext = media.img.split('.').pop()
          if (this.mediaExtensions.img.includes(ext)) return 'image'
        } else if (media.sources && media.poster) {
          // other validations
          return 'video'
        }
      }
    },
    playerOptions () {
      return (media) => {
        return {
          height: '360',
          fluid: true,
          autoplay: false,
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: media.sources,
          poster: media.poster
        }
      }
    }
  },
  methods: {
    goSettings(){
      window.open('/profile/settings/?activeTab=connections', '_blank');
    },
    getCreatedDateSecretary() {
      return this.secretaryModalView.created_at ? moment(this.secretaryModalView.created_at).format("MMMM DD, YYYY") : '';
    },
    editNewClinicForm(clinic) {
      this.editingClinic = true;
      this.$modal.show('newClinicModal')
    },
    addNewClinic(){
      
      // console.log(this.newClinic);
      let newClinicObj = new Object();
      newClinicObj.address = this.newClinic.address,
      newClinicObj.address_2 = this.newClinic.address2,
      newClinicObj.phone = [this.newClinic.phone],
      newClinicObj.city = this.newClinic.city,
      newClinicObj.zone = this.newClinic.zone,
      newClinicObj.country = this.newClinic.country.name,
      newClinicObj.title = this.newClinic.title,
      newClinicObj.notes = this.newClinic.notes,
      newClinicObj.meta = {"type": this.newClinic.type };

      this.$store.dispatch('addClinic',newClinicObj).then(response => {
            // console.log(response);
            this.showAlert('success','Clinica Agregada','Clinica Agregada éxitosamente!');
            this.newClinic = this.newClinicDef;
            this.$modal.hide('newClinicModal');
        }, error => {
            console.error(error);
            this.showAlert('danger','Error al agregar clinica',error.response.data.error);
        });
      
    },
    editNewSecretaryForm(secretary) {
      this.editingSecretary = true;
      this.cleanNewSecretaryForm();
      // this.newSecretary = Object.assign(this.newSecretary, secretary);
      for (const key in this.newSecretary) {
        if (Object.hasOwnProperty.call(this.newSecretary, key) && Object.hasOwnProperty.call(secretary, key)) {
          this.newSecretary[key] = secretary[key];
        }
      }

      // Set id
      this.newSecretary.id = secretary.id;

      if (secretary.meta && secretary.meta.personal_id_type) {
        this.newSecretary.idType = secretary.meta.personal_id_type;
      }
      if (secretary.meta && secretary.meta.personal_id) {
        this.newSecretary.idNum = secretary.meta.personal_id;
      }
      if (secretary.meta && secretary.meta.about) {
        this.newSecretary.about = secretary.meta.about;
      }

      this.$modal.show('newSecretaryModal');
    },
    validateNewClinic(){
      //console.log(this.newClinic);
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('new-clinic').then(result => {
          if (result) {
            this.addNewClinic();
            resolve(true);
          } else {
            reject('correct all values')
          }
        })
      })
    },
    // VALIDATIONS
    validateNewSecretary(){
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('new-secretary').then(result => {
          if (result) {
            if(this.editingSecretary) {
              this.editSecretary();
            } else {
              this.addNewSecretary();
            }
            resolve(true);
          } else {
            reject('correct all values')
          }
        })
      })
    },
    cleanNewSecretaryForm() {
      this.newSecretaryDefault.phone = [];
      this.newSecretary = Object.assign(this.newSecretary, this.newSecretaryDefault);
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
    },
    openNewClinicForm() {
      this.editingClinic = false;
      this.$modal.show('newClinicModal');
    },
    openNewSecretaryForm() {
      this.editingSecretary = false;
      this.cleanNewSecretaryForm();
      this.$modal.show('newSecretaryModal');
    },
    addNewSecretary(){
      const newSecretary = Object.assign({}, this.newSecretary);
      this.newSecretary.idType ? 
        newSecretary.meta.personal_id_type = this.newSecretary.idType : null;

      this.newSecretary.idNum ? 
        newSecretary.meta.personal_id = this.newSecretary.idNum : null;

      this.newSecretary.about ? 
        newSecretary.meta.about = this.newSecretary.about : null;

      newSecretary.active = true;

      if(newSecretary.country && newSecretary.country.name){
          newSecretary.country = newSecretary.country.name;
      }

      // Clean object
      delete newSecretary.id;
      delete newSecretary.idNum;
      delete newSecretary.idType;
      delete newSecretary.about;

      newSecretary.meta.doctor_id = this.activeUserInfo.id;

      newSecretary.meta.doctorsList = [
        {
          doctorId: this.activeUserInfo.id,
          active: true,
          doctorData: this.activeUserInfo
        }
      ];

      // Clean unused variables
      for (const key in newSecretary) {
        if (Object.hasOwnProperty.call(newSecretary, key) && !newSecretary[key]) {
            delete newSecretary[key];
        }
      }

      this.$store.dispatch('registerPatientPublic', newSecretary).then(response => {
            console.log(response);
            this.$store.dispatch('fetchSecretaries');
            this.showAlert('success','Secretaria Agregada','Secretaria con ID #' + response.data.data.user.id + ' Agregado éxitosamente!');
            const payload = {
              doctor_name: `${this.activeUserInfo.first_name} ${this.activeUserInfo.last_name}`,
              secretary_id: response.data.data.user.id,
              secretary_email: newSecretary.email,
              created_at: response.data.data.user.created_at
            };
            this.$store.dispatch('notifyNewSecretaryCreation', payload);
            this.$modal.hide('newSecretaryModal');
            this.cleanNewSecretaryForm();
        }, error => {
            console.error(error.response);
            if(error.response.data.error == 'The email address is already in use by another account.') {
              // this.cleanNewSecretaryForm();
              this.$modal.hide('newSecretaryModal');
              this.$store.dispatch('fetchAllUsers').then(userResponse => {
                const matchUser = userResponse.data.data.users.find(user => user.email === newSecretary.email);
                if(matchUser && matchUser.role === 'secretary') {
                  const isDoctorTeammate = Array.isArray(matchUser.meta.doctorsList) 
                  ? matchUser.meta.doctorsList.find(doctor => doctor.doctorId === this.activeUserInfo.id)
                  : null;
                  if(!isDoctorTeammate) {
                    this.linkedSecretary = matchUser;
                    this.$modal.show('linkSecretaryModal');
                  } else {
                    this.showAlert('danger','No es posible vincular este usuario.', `${matchUser.first_name} ${matchUser.last_name} ya pertenece a su equipo.`);
                  }
                } else {
                  this.showAlert('danger','No es posible vincular este usuario.',error.response.data.error);
                }
              });
            }
            else {
              this.showAlert('danger','Error al agregar a la secretaria.',error.response.data.error);
            }
        });
      
    },
    closeRemoveClinicModal() {
      this.$modal.hide("RemoveClinicModal")
    },
    removeSecretary() {
      const newSecretary = { id: this.newSecretary.id, active: false};
      this.$store.dispatch('removeSecretary', newSecretary).then(response => {
            console.log(response);
            this.showAlert('success','Secretaria Removida','Secretaria con ID #'+this.newSecretary.id+' removida éxitosamente!');
            this.cleanNewSecretaryForm();
            this.closeRemoveSecretaryModal();
        }, error => {
            console.error(error.response);
            this.showAlert('danger','Error al remover a la secretaria.',error.response.data.error);
        });
    },
    RemoveClinic() {

      this.$store.dispatch('removeClinic', this.deleteClinic).then(response => {
            console.log(response);
            this.showAlert('success','Clinica Removida','Clinica con ID #'+this.deleteClinic+' removida éxitosamente!');
            this.cleanNewSecretaryForm();
            this.closeRemoveSecretaryModal();
        }, error => {
            console.error(error.response);
            this.showAlert('danger','Error al remover a la secretaria.',error.response.data.error);
        });
    },
    RemoveClinicModal(clinic){
      this.deleteClinic = clinic.id
      this.$modal.show('RemoveClinicModal')
    },
    linkSecretary() {
      const linkSecretary = { email: this.newSecretary.email, doctor_id: this.activeUserInfo.id };
      this.$store.dispatch('linkUserPublic', linkSecretary).then(response => {
            const doctorData = {
              doctorId: this.activeUserInfo.id,
              active: true,
              doctorData: this.activeUserInfo
            };
            Array.isArray(this.linkedSecretary.meta.doctorsList) 
            ? this.linkedSecretary.meta.doctorsList.push(doctorData)
            : this.linkedSecretary.meta.doctorsList = [doctorData];            
            const metaUpdatesUser = {
              id: this.linkedSecretary.id,
              meta: this.linkedSecretary.meta
            };
            this.$store.dispatch('editUser', metaUpdatesUser);
            console.log(response);
            this.$store.dispatch('fetchSecretaries');
            this.showAlert('success','Secretaria Vinculada','Secretaria vinculada éxitosamente!');
            this.cleanNewSecretaryForm();
            this.closeLinkSecretaryModal();
            const payload = {
              doctor_name: `${this.activeUserInfo.first_name} ${this.activeUserInfo.last_name}`,
              secretary_email: linkSecretary.email,
              secretary_phone: this.newSecretary.phone
            };
            this.$store.dispatch('notifyLinkSecretary', payload);
        }, error => {
            console.error(error.response);
            this.showAlert('danger','Error al remover a la secretaria.',error.response.data.error);
        });
    },
    editSecretary(){
      const newSecretary = Object.assign({}, this.newSecretary);
      this.newSecretary.idType ? 
        newSecretary.meta.personal_id_type = this.newSecretary.idType : null;

      this.newSecretary.idNum ? 
        newSecretary.meta.personal_id = this.newSecretary.idNum : null;

      this.newSecretary.about ? 
        newSecretary.meta.about = this.newSecretary.about : null;

      // newSecretary.active = true;

      if(newSecretary.country && newSecretary.country.name){
          newSecretary.country = newSecretary.country.name;
      }

      // Clean object
      delete newSecretary.idNum;
      delete newSecretary.idType;
      delete newSecretary.about;
      delete newSecretary.email;

      // Clean unused variables
      for (const key in newSecretary) {
        if (Object.hasOwnProperty.call(newSecretary, key) && !newSecretary[key]) {
            delete newSecretary[key];
        }
      }

      this.$store.dispatch('editUser', newSecretary).then(response => {
            console.log(response);
            this.editingSecretary = false;
            this.$store.dispatch('fetchSecretaries');
            this.showAlert('success','Secretaria Modificada','Secretaria actualizada éxitosamente!');
            this.cleanNewSecretaryForm();
            this.$modal.hide('newSecretaryModal');
        }, error => {
            console.error(error.response);
            this.showAlert('danger','Error al editar datos.',error.response.data.error);
        });
      
    },
    showAlert (color,title,text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text
      });
    },
    openRemoveSecretaryModal(secretary) {
      // Set id
      this.newSecretary.id = secretary.id;

      this.$modal.show('removeSecretaryModal')
    },
    closeRemoveSecretaryModal() {
      this.$modal.hide('removeSecretaryModal')
    },
    closeLinkSecretaryModal() {
      this.$modal.hide('linkSecretaryModal')
    },
    submitForm () {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.editting = !this.editting; 
          // TODO editUser

          this.$store.dispatch('evolugy/updateUser', this.userData);
        } else {
          console.log('errores');
          // form have errors
        }
      })
    },
    getTeam(){

    },
    openTeamMemberModal(secretary){
      this.secretaryModalView = Object.assign({}, secretary);
      this.$modal.show('teamMemberModal');
    },
    openClinicModal(clinic) {
      this.clinicModalView = Object.assign({}, clinic);
      this.$modal.show('clinicModal')
    },
    loadContent () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#button-load-more-posts',
        scale: 0.45
      })
      setTimeout(() => {
        this.$vs.loading.close('#button-load-more-posts > .con-vs-loading')
      }, 3000)
    }
  },
  components: {
    Datepicker,
    vSelect,
    flatPickr
  },
  created (){
    this.$store.dispatch('fetchClinics');
    console.log('USER: ',this.$store.state.AppActiveUser);
    this.userData = JSON.parse(JSON.stringify(this.$store.state.AppActiveUser))
    this.evolugyUser = JSON.parse(window.localStorage.getItem('userInfo'));
    // console.log(this.evolugyUser);
    // this.userData.first_name = this.evolugyUser.first_name,
    // this.userData.last_name = this.evolugyUser.last_name,
    // this.userData.dob = this.evolugyUser.dob,
    // this.userData.gender = this.evolugyUser.gender,
    // this.userData.phone[0] = this.evolugyUser.phone[0],
    // this.userData.linkedin = this.evolugyUser.linkedin,
    // this.userData.address = this.evolugyUser.address,
    // this.userData.address_2 = this.evolugyUser.address_2,
    // this.userData.zone = this.evolugyUser.zone,
    // this.userData.city = this.evolugyUser.city,
    // this.userData.country = this.evolugyUser.country;
    this.teamMember = this.getTeam();
  },
  mounted () {
    this.wasSidebarOpen = this.$store.state.reduceButton
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
    
  },
  beforeDestroy () {
    if (!this.wasSidebarOpen) this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
  },
  beforeCreate(){
      this.$store.dispatch('fetchSecretaries');
  },
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
</style>

<style scoped>
.gradient-bg{
  background: rgb(0,51,161);
  background: -moz-linear-gradient(90deg, rgba(0,51,161,1) 0%, rgba(0,167,225,1) 100%);
  background: -webkit-linear-gradient(90deg, rgba(0,51,161,1) 0%, rgba(0,167,225,1) 100%);
  background: linear-gradient(90deg, rgba(0,51,161,1) 0%, rgba(0,167,225,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#0033a1",endColorstr="#00a7e1",GradientType=1);
}
</style>
